
<template>
  <vs-popup class="holamundo" popup-class="w-9/12" :title="title" :active.sync="popupActive">
    <div v-if="commission.paymentType">
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-3/12 flex-inline">
          <span>نوع پرداخت:</span>
        </div>
        <div class="vx-col sm:w-7/12 flex-inline">{{PaymentType[commission.paymentType].title}}</div>
      </div>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-3/12 flex-inline">
          <span>نوع کارمزد:</span>
        </div>
        <div class="vx-col sm:w-7/12">{{CommissionType[commission.commissionType].title}}</div>
      </div>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-3/12 flex-inline">
          <span>نوع کاربر:</span>
        </div>
        <div class="vx-col">
          {{ this.commission.userType==1?'پذیرنده':
          'مشتری'}}
        </div>
      </div>

      <vx-card class="mb-2">
        <div
          class="vx-row mb-2"
          v-if="commission.commissionType && ['Percent','Fixed'].includes(CommissionType[commission.commissionType].value)"
        >
          <div class="vx-col sm:w-3/12 flex-inline title">
            <span>مقدار:</span>
          </div>
          <div class="vx-col">
            <span v-if="this.CommissionType[this.commission.commissionType].value=='Percent'">%</span>
            {{ commissionFee.val}}
          </div>
        </div>
        <div
          class="vx-row mb-2"
          v-if="commission.commissionType && ['Percent','Tiered'].includes(CommissionType[commission.commissionType].value)"
        >
          <div class="vx-col sm:w-3/12 flex-inline title">
            <span>سقف:</span>
          </div>
          <div class="vx-col">{{ commissionFee.ceilVal}}</div>
        </div>
        <table
          class="commission-fees"
          v-if="commission.commissionType && 'Tiered'==CommissionType[commission.commissionType].value"
        >
          <tr class="mb-2" v-for="(item, index) in commissionFee.items" :key="index">
            <td class="title">
              <span>از:</span>
            </td>
            <td class>{{ item.min}}</td>
            <td class="title">
              <span>تا:</span>
            </td>
            <td class>{{commissionFee.items.length-1>index? item.max:"∞"}}</td>
            <td class="title">
              <span>مقدار:</span>
            </td>
            <td class>
              <span v-if="item.isPercent">%</span>
              {{ item.val}}
            </td>
          </tr>
        </table>
      </vx-card>
    </div>
  </vs-popup>
</template>
<style lang="scss">
.commission-fees{
  td:not(.title) {
    padding-right: 80px;
    padding-left: 8px;
  }
}
</style>
<script>
import {  CommissionType, PaymentType } from "@/enums.js";

export default {
  name: "view-commission",
  data() {
    return {
      CommissionType,
      PaymentType,
      popupActive: false,
      commission: {
        commissionType: 2
      },
      selectedUserType: "m",
      selectedPaymentType: null,
      commissionFee: {
        val: 0,
        ceilVal: 0,
        items: [{ min: 0, max: 0, val: 0, isPercent: true }]
      },
      title: ""
    };
  },
  methods: {
    show(id, name) {
        this.title = 'نمایش کارمزد "' + name + '"';
        this.get(id);
      this.popupActive = true;
    },
    async get(id) {
      let loading = this.$vs.loading();
      //this.$vs.loading()

      let payload = {
        params: {
          id: id
        }
      };
      this.$http
        .get("/api/services/app/Commissions/GetCommissionForEdit", payload)
        .then(async response => {
          this.commission = response.data.result.commission;
          this.selectedUserType = this.commission.userType == 1 ? "m" : "c";
          this.commissionFee = JSON.parse(this.commission.commissionFee);
          this.$vs.loading.close();
        }) //end success
        .catch(error => {
          this.$vs.loading.close();
        }); //end http
    },
  }
};
</script>